import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Footer from "./components/footer";
import Hero from "./components/Hero";
import Services from "./components/services";
import Choose from "./components/choose";
import Contact from "./components/contact";

import Solar from "./pages/Solar";
import Robotics from "./pages/Robotics";
import VR from "./pages/VR";
import WebApp from "./pages/WebApp";
import Marketing from "./pages/Marketing";
import Automation from "./pages/Automation";
import CreativeArts from "./pages/CreativeArts";
import SchoolERP from "./pages/SchoolERP";
import SmartPanels from "./pages/SmartPanels";
import AOS from "aos";
import "aos/dist/aos.css";


function App() {
  const location = useLocation();

  // first initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-in-out",
      once: false,   // <-- allow animation every time
      mirror: false,
    });
  }, []);

  // re-run animations on page change
  useEffect(() => {
    AOS.refreshHard(); // <-- Best refresh method
  }, [location.pathname]);


  return (
    <div className="font-sans bg-gray-100 min-h-screen">
      <Header />
      <Navbar />

      <Routes>
        <Route path="/" element={<><Hero /><Services /><Choose /><Contact /></>} />

        <Route path="/solar" element={<Solar />} />
        <Route path="/robotics" element={<Robotics />} />
        <Route path="/vr" element={<VR />} />
        <Route path="/web-app" element={<WebApp />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/automation" element={<Automation />} />
        <Route path="/smart-panels" element={<SmartPanels />} />
        <Route path="/creative-arts" element={<CreativeArts />} />
        <Route path="/school-erp" element={<SchoolERP />} />
      </Routes>

      <Footer />
    </div>
  );
}


export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
